// ©2024 Austin App House. All rights reserved.
const values = {
  lastName: '',
  firstName: '',
  phone: '',
  email: '',
  role: '',
};

export default values;
